<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="12">
          <v-card>
            <v-card-title>
              Agregar monto límite para saldo disponible
            </v-card-title>
            <v-card-text>
              <v-text-field
                label="Monto límite"
                type="number"
                v-model.number="balanceLimit"
                @blur="updateBalanceLimit"
                @keydown.enter="updateBalanceLimit"
                :rules="balanceLimitRules"
              />
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12">
          <v-card height="100%">
            <v-data-table
              :loading-text="table.title"
              :loading="table.loading"
              :headers="table.headers"
              :items="table.data"
              item-key="areaId">
              <template v-slot:item.areaName="{ item }">
                {{ item.areaName }}
              </template>
              <template v-slot:item.percentage="{ item }">
                <v-edit-dialog
                  v-model="dialog"
                  :return-value.sync="item.percentage"
                  @click="editPercentage(item)"
                  @save="savePercentage(item)">
                  <div style="display: flex; align-items: center;">
                    {{ item.percentage }}%
                  <v-icon small class="ml-2">mdi-pencil</v-icon>
                  </div>
                  <template v-slot:input>
                    <v-text-field
                      v-model="item.percentage"
                      type="number"
                      :rules="percentageRules"
                    />
                  </template>
                </v-edit-dialog>
              </template>
              <template v-slot:item.amount="{ item }">
                {{ item.amount | toFixNumber(2) | numberWithComma  | prefix('$') }} MXN
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-spacer></v-spacer>
    <v-container class="d-flex flex-row-reverse pa-3">
      <v-btn class="ma-2 pa-2" color="primary" @click="openConfirmDialog">Confirmar</v-btn>
      <v-btn class="ma-2 pa-2" @click="load">Restablecer valores</v-btn>
    </v-container>
    <v-dialog @keydown.esc="confirmDialog=false" v-model="confirmDialog" persistent width="500">
      <v-card>
        <v-card-title>Confirmar administración de saldo</v-card-title>
        <v-card-text>
          ¿Está seguro de que desea guardar los cambios en su saldo?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="confirmDialog = false">Cancelar</v-btn>
          <v-btn color="primary" @click="save">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" :color="snackBarColor">
      {{ snackbarText }}
    </v-snackbar>
  </div>
</template>

<script>
import Restaurant from '@/models/Restaurant'

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data () {
    const restaurantModel = new Restaurant()
    return {
      balanceLimit: 0,
      formValid: false,
      dialog: false,
      snackbar: false,
      confirmDialog: false,
      snackbarText: '',
      snackBarColor: null,
      restaurantModel,
      table: {
        title: 'Cargando áreas...',
        loading: true,
        headers: [
          { text: 'Area', value: 'areaName', sortable: false },
          { text: 'Porcentaje', value: 'percentage', sortable: false },
          { text: 'Monto', value: 'amount', sortable: false }
        ],
        data: []
      }
    }
  },
  computed: {
    percentageRules () {
      return [
        v => !!v || 'El porcentaje es requerido',
        v => Number(v) >= 0 || 'El porcentaje debe ser mayor a 0',
        v => Number(v) <= 100 || 'El porcentaje debe ser menor a 100'
      ]
    },
    balanceLimitRules () {
      return [
        v => Number(v) > 0 || 'El monto límite debe ser mayor a 0'
      ]
    },
    restaurant () {
      return this.$store.state.currentRestaurant.data
    },
    areas () {
      return this.$store.state.currentRestaurant.areas.data || []
    },
    amountAvailable () {
      return this.$store.state.amountAvailable
    }
  },
  async mounted () {
    await this.load()
  },
  methods: {
    async updateBalanceLimit () {
      if (this.balanceLimit > 0) {
        try {
          await this.$api.post(`/v1/restaurants/${this.restaurant._id}`, { balanceLimit: this.balanceLimit })
          this.snackBarColor = 'success'
          this.snackbarText = 'Se guardo el monto límite correctamente'
          this.snackbar = true
          this.confirmDialog = false
        } catch (error) {
          this.snackBarColor = 'error'
          this.snackbarText = error.message
          this.snackbar = true
          this.confirmDialog = false
        }
      }
    },
    openConfirmDialog () {
      this.confirmDialog = true
    },
    editPercentage (item) {
      this.dialog = true
    },
    savePercentage (item) {
      this.dialog = false
      item.percentage = Number(item.percentage)
      item.amount = Number((Number(item.percentage) * Number(this.amountAvailable) / 100).toFixed(2))
    },
    isPercentageValid (value) {
      let total = 0
      if (Number(value) > 100) {
        return false
      }
      this.table.data.forEach((area) => {
        total += (Number(area.percentage) === Number(value) ? Number(value) : Number(area.percentage))
      }, 0)

      return Number(total + value) <= 100
    },
    async load () {
      this.table.loading = true
      this.table.data = this.areas.map(area => {
        return {
          areaId: area.id,
          areaName: area.name,
          percentage: 0,
          amount: 0
        }
      })

      try {
        this.restaurantModel.set(this.restaurant)
        const response = await this.restaurantModel.detail()
        const customBalance = response.response.data.balance.managedBalance
        if (customBalance) this.table.data = customBalance
        if (response.response.data.balanceLimit) this.balanceLimit = response.response.data.balanceLimit
      } catch (error) {
        this.snackBarColor = 'error'
        this.snackbarText = error.message
        this.snackbar = true
      }
      this.table.loading = false
    },
    async save () {
      try {
        await this.$api.post(`/v1/restaurants/${this.restaurant._id}/balance/manage`, {
          active: true,
          customBalance: this.table.data
        })
        this.snackBarColor = 'success'
        this.snackbarText = 'La configuración de saldo se ha guardado exitosamente'
        this.snackbar = true
        this.confirmDialog = false
      } catch (error) {
        this.snackBarColor = 'error'
        this.snackbarText = error.message
        this.snackbar = true
        this.confirmDialog = false
      }
    }
  }
}
</script>
